import { DependencyToken, container } from "core.app";
import { ExoPlayerVideoPlayer } from "core.components";

export const overrideContainer = () => {
  container.bindValue({
    value: ExoPlayerVideoPlayer,
    token: DependencyToken.VideoPlayer,
  });
};

export default overrideContainer;
